var render = function render(){var _vm=this,_c=_vm._self._c;return _c('template-page',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"msg-error"},[_c('router-view')],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }